/**
 * @author vishwadeep.kapoor
 * @Date: 20-04-16 12:24:50
 * @Last Modified by: vishwadeep
 * @Last Modified time: 2020-11-27 16:08:33
 */

import React, { PureComponent } from 'react';
import { createStructuredSelector } from 'reselect';
import { connect } from 'react-redux';
import { func, shape, string, bool } from 'prop-types';

import { fetchGiftCardList } from './actions';
import {
  DEFAULT_GIFTCARD_PAYLOAD,
  DEFAULT_GIFTCARD_CLIENT,
  DEFAULT_PRODUCT_TYPES,
  DEFAULT_GIFTCARD_PAYLOAD_BY_NAME,
  VALIDATE_MERCHANDISE,
  DEFAULT_MERCHANDISE_PRODUCT_TYPES,
  DEFAULT_GIFTCARD_PAYLOAD_MANIPAL,
  DEFAULT_GIFTCARD_SPECIAL_DEALS_AND_OFFERS,
  DEFAULT_EVOUCHER_MERCHANDISE,
} from './constants';
import { selectUserDetails } from '../HeaderContainer/selectors';
import GiftCard from '../GiftCard/';
import { constants, utils } from '../../devUtils';
import endPoints from '../../config/endPoints';

class GiftCardsList extends PureComponent {
  constructor(props) {
    super(props);
    const { match: { params: { filterName } } } = props;
    this.filter = {
      filterName: null,
      filterId: null,
    };
    this.stateLessKeys = {
      filterName,
      initialPayload: {},
    };
  }

  componentWillMount() {
    const {
      history: {
        location: {
          pathname,
          state: {
            filterType = null,
            name = null,
          } = {},
        } = {},
      },
      onGetGiftCardList,
      GetUserDetails,
      GetUserDetails: { client_id = '' } = {},
    } = this.props;
    const { filterName } = this.stateLessKeys;
    let payload = DEFAULT_GIFTCARD_PAYLOAD_BY_NAME;

    if (filterName) {
      payload.category_names = filterName;
      this.filter = { filterName: filterType, filterId: name };
    } else if (filterType) {
      payload = DEFAULT_GIFTCARD_PAYLOAD;
      payload[filterType] = name;
      this.filter = {
        filterName: filterType,
        filterId: name,
      };
    } else if (pathname === constants.LINK_CLIENT_MANIPAL) {
      payload = {
        ...DEFAULT_GIFTCARD_PAYLOAD,
        category_ids: '',
        product_types: DEFAULT_MERCHANDISE_PRODUCT_TYPES,
        vendor_ids: '',
        client_series: endPoints.MANIPAL_SERIES,
      };
    } else if (pathname === constants.LINK_PROPEL_CORPORATE_GIFITING_HOME) {
      payload = {
        ...DEFAULT_GIFTCARD_PAYLOAD,
        category_ids: '',
        product_types: DEFAULT_EVOUCHER_MERCHANDISE,
        vendor_ids: '',
        client_series: endPoints.PROPEL_CORPORATE_GIFTING,
      };
    } else if (pathname === constants.LINK_SPECIAL_DEALS_AND_OFFERS) {
      payload = {
        ...DEFAULT_GIFTCARD_PAYLOAD,
        category_ids: '',
        client_ids: '',
        product_types: DEFAULT_PRODUCT_TYPES,
        vendor_ids: '',
        min_discount: 5,
        max_discount: 100,
      };
    } else {
      payload = {
        ...DEFAULT_GIFTCARD_PAYLOAD,
        category_ids: '',
        product_types: DEFAULT_PRODUCT_TYPES,
        vendor_ids: '',
      };
    }
    payload = VALIDATE_MERCHANDISE(payload, GetUserDetails);
    if (pathname === constants.LYRA_PG_LINK_GIFTCARD_LIST && client_id) {
      payload = {
        ...payload,
        client_ids: client_id,
      };
    }
    this.stateLessKeys.initialPayload = payload;
    onGetGiftCardList(payload);
  }

  componentWillReceiveProps(nextProps) {
    const { GetUserDetails, GetUserDetails: { isOnlyMerchandise = false } } = nextProps;
    const { GetUserDetails: _GetUserDetails, onGetGiftCardList } = this.props;
    if (!utils.isEqual(GetUserDetails, _GetUserDetails) && isOnlyMerchandise) {
      const { initialPayload } = this.stateLessKeys;
      onGetGiftCardList(initialPayload);
    }
  }

  render() {
    const {
      history,
      location,
      route,
      GetUserDetails: {
        isOnlyMerchandise = false,
        client_id,
      },
    } = this.props;
    const { initialPayload } = this.stateLessKeys;
    return (
      <GiftCard
        history={history}
        location={location}
        route={route}
        client_id={isOnlyMerchandise ? client_id : DEFAULT_GIFTCARD_CLIENT}
        filter={this.filter}
        initialPayload={initialPayload}
      />
    );
  }
}

GiftCardsList.propTypes = {
  onGetGiftCardList: func.isRequired,
  history: shape({
    location: shape({}),
  }).isRequired,
  location: shape({}).isRequired,
  route: shape({}).isRequired,
  GetUserDetails: shape({
    isOnlyMerchandise: bool,
    client_id: string,
  }).isRequired,
  match: shape({
    params: shape({
      filterName: string,
    }),
  }).isRequired,
};

const mapDispatchToProps = (dispatch) => ({
  onGetGiftCardList: (payload) => dispatch(fetchGiftCardList(payload)),
});

const mapStateToProps = createStructuredSelector({
  GetUserDetails: selectUserDetails(),
});

const component = connect(mapStateToProps, mapDispatchToProps)(GiftCardsList);

export { GiftCardsList, mapDispatchToProps, mapStateToProps };
export default component;



// WEBPACK FOOTER //
// client/containers/GiftCardsList/index.js